import React, { useEffect, useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Button,
  Row,
  Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { isEmpty } from "lodash";
import Logo from "components/Logo";
import { logout } from "oidc";
import poweredBy from "assets/images/powered_by_pharmaforce.svg";
import useSignalr from "hooks/useSignalr";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip';
import usericon from 'assets/icon/user-icon.svg';
import Export from "assets/icon/ExportDownload.svg";
import ExportCancel from "assets/icon/ExportCancelIcon.svg";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Loader from "components/Loader";
import moment from 'moment';
import DownLoadingPending from "assets/icon/ExportDownloads.svg";
import ExportPending from "assets/icon/ExportPending.svg";
import DownLoadingCompleted from "assets/icon/ExportDownloadComplete.svg";

const Header = () => {
  const [isOpen, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const signalR = useSignalr();
  (signalR, "in header");
  const [user, setUser] = useState('');
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [downloadHistory, setDownloadHistory] = useState([]);

  useEffect(() => {
    if (signalR.count >= 1) {
      setIsLoading(true);

      // if (signalR && signalR.messages && signalR.messages.length > 0) {
      // }
    } else {
      setIsLoading(false);
    }
  }, [signalR.messages, signalR.count, isLoading]);
  useEffect(() => {
    if (signalR.messages.length !== 0) {
      // let estDate = moment.tz(signalR.messages.fileGeneatedDate, "America/New_York");
      // let fileGeneatedDate = estDate.clone().tz(moment.tz.guess());
      // signalR.messages.fileGeneatedDate = fileGeneatedDate;
      setDropdownOpen(true);
    }
    if (signalR.count == 1) {
      setDropdownOpen(true);
    }
  }, [signalR.messages, signalR.count]);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const interval = setInterval(() => { }, 1000);
    const { username } = profile || {};
    const { sub } = profile || {};
    setUserName(username);
    // setUserId(sub);
    const theme = localStorage.getItem("theme") || "PF";

    // if (theme === "PF") setHidePoweredBy(true);
    if (!access_token) {
      navigate("/");
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  const fetchData = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub, username } = profile || {};
    try {
      setLoading(true);
      setUser(username);
      // const { data } = await axios.get(
      //   `${process.env.REACT_APP_USER_ENDPOINT}/users/User/getUserDetails`,
      //   {
      //     params: { Id: sub },
      //     headers: {
      //       "Content-type": "application/json",
      //       Authorization: `${token_type} ${access_token}`,
      //     },
      //   }
      // );
      // setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const AppModuleName = (gridCode) => {
  let moduleName = "";
  if (gridCode.indexOf("purchaseorder") !== -1) {
    moduleName = "Purchase Order";
  } else if (gridCode.indexOf("rxmanager") !== -1) {
    moduleName = "Rx Manager";
  } else if (gridCode.indexOf("accumulation") !== -1) {
    moduleName = "Accumulations Details";
  } else if (gridCode.indexOf("purchaseorder") !== -1) {
    moduleName = "Purchase Orders";
  } else if (gridCode.indexOf("inventory") !== -1) {
    moduleName = "Accumulations";
  } else if (gridCode.indexOf("ceconfiguration") !== -1) {
    moduleName = "Configuration";
  } else if (gridCode.indexOf("invoice") !== -1) {
      moduleName = "Invoice";
  } 
  else if (gridCode.indexOf("purchaseorder") !== -1) {
      moduleName = "Purchase Order";
    }
    else if (gridCode.indexOf("DrugCatalog") !== -1) {
      moduleName = "DrugCatalog";
    }
    else if (gridCode.indexOf("Non340BPurchaseOrder") !== -1) {
      moduleName = "Non340BPurchaseOrder";
    }
    else if (gridCode.indexOf("PODetails") !== -1) {
      moduleName = "PODetails";
    }
    else if (gridCode.indexOf("POClaims") !== -1) {
      moduleName = "POClaims";
    }
    else if (gridCode.indexOf("non340BPODetails") !== -1) {
      moduleName = "Non340BPODetails";
    }
    else if(gridCode.indexOf("nonreplenishedclaimreports") !== -1)
    {
      moduleName = "NonReplenishedClaimReports";
    }
    else if (gridCode.indexOf("replenishedclaimreports") !== -1){
      moduleName = "ReplenishedClaimReports" ;
    }
    
    else if(gridCode.indexOf("purchaseorderclaimreports") !== -1)
    {
       moduleName = "PODetails";
    }
    else if(gridCode.indexOf("nonderivedclaimreports") !== -1)
    {
      moduleName = "NonDerivedClaimReports";
    }
    else if(gridCode.indexOf("claimreports") !== -1)
    {
       moduleName = "ClaimReports";
    }
    else if(gridCode.indexOf("formulary") !== -1)
    {
       moduleName = "Formulary";
    }
    return moduleName;

  };

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
  };

  const handelToggle = () => {
    setLoading(true);
    getDownloadHistory();
    setOpen(!isOpen);
  };

  const getDownloadHistory = async () => {
    //
    setLoading(true);

    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_MESSAGE_ENDPOINT}/api/Download/DownloadHistory/GWClientUI`,
        {
          //params: { Id: sub },
          headers: {
            "Content-type": "application/json",
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      setLoading(true);

      if (data) {
        let x = data;
        setOpen(!isOpen);
        data.map((item, index) => {
          if (Array.isArray(item.dataExportMessages)) {
            item.dataExportMessages.map((item1, index) => {
              item1.gridCode = AppModuleName(item1.gridCode);
              // let estDate = moment.tz(item1.fileGeneatedDate, "America/New_York");
              // item1.fileGeneatedDate = estDate.clone().tz(moment.tz.guess());
            });
          }
        });
        setDownloadHistory(data);
        setLoading(false);
      }
    } catch (ex) { }
  };
  const download = async (dataExportId) => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    window.open(
      `${process.env.REACT_APP_MESSAGE_ENDPOINT}/api/Download/Download/${dataExportId}?access_token=${access_token}`
    );
    // try {
    //   const { access_token } =
    //     JSON.parse(localStorage.getItem('pharmaforce')) || {};
    //   const res = await axios.get(`${process.env.REACT_APP_MESSAGE_ENDPOINT}/Download/Download/${dataExportId}?access_token=${access_token}`,
    //     {
    //       responseType: 'blob',
    //     }
    //   );
    //   if (res.request.responseType === 'blob') {
    //     window.open(res.request.responseURL);
    //   }
    // } catch (error) {
    // }
  };
  (downloadHistory, "downlaod");


  return (
    <>
      <Navbar color="white" light className="app-header">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex align-items-center">
            <NavbarBrand href="/" className="me-0">
              <Logo height={50} />
            </NavbarBrand>
            <h2 className="ps-3 ms-3 text-primary d-inline mx-1 mt-1 mb-0 top_hed">
              RxGateway
            </h2>
          </div>
          <div>

            {
              // <Nav className="ps-4 ms-auto">
              //   <UncontrolledDropdown nav className="profile-dropdown mb-4">
              //     <DropdownToggle nav caret className="font-weight-600 f-16">
              //       {user}
              //       {/* {!isEmpty(data) ? data.firstName + " " + data.lastName : ""} */}
              //     </DropdownToggle>
              //     <DropdownMenu className="shadow">
              //       <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
              //     </DropdownMenu>
              //   </UncontrolledDropdown>
              // </Nav>


              <Nav className='nav_info'>

                {/* <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav caret className='font-weight-500' style={{ fontSize: "14px", }}>
                <span className=''><img style={{ background: "#702C621A", padding: "7px", borderRadius: "50px", marginRight: "8px", }} src={user} alt="" /></span>
                {profileObject ? profileObject.profile.username : ''}
              </DropdownToggle>
              <DropdownMenu className='shadow'>
                <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}



                {/* <UncontrolledDropdown nav className="profile-dropdown">
              <DropdownToggle
                nav
                className=""
                style={{ position: "relative" }}
              >
                <OverlayTrigger
                  overlay={(props) => (
                    <Tooltip {...props}>Notification Center</Tooltip>
                  )}
                  placement="bottom"
                >
                  <img src={notification} alt="" />
                </OverlayTrigger>
                <span id="spnNotificationCnt" className="notifcnt"></span>
              </DropdownToggle>
            </UncontrolledDropdown> */}
                 <UncontrolledDropdown
                  nav
                  className="profile-dropdown"
                  isOpen={dropdownOpen}
                  toggle={toggleDropdown}
                >
                  <DropdownToggle
                    nav
                    className=""
                    style={{ position: "relative" }}
                  >
                    <OverlayTrigger
                      overlay={(props) => (
                        <Tooltip {...props}>Export Notifications</Tooltip>
                      )}
                      placement="bottom"
                    >
                      {/* <img src={Export} alt="" /> */}
                      {/* {isLoading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "-20%",
                          // transform: "translate(-50%, -50%)",
                        }}
                      />
                    ) : (
                      <img src={Export} alt="Export" />
                    )} */}
                      {isLoading ? (
                        <div className="spinner-container">
                          {/* <Spinner
                          animation="border"
                          size="sm"
                          className="spinner-overlay"
                        /> */}
                          <img
                            src={Export}
                            alt="Export"
                            className="export-image"
                          />
                        </div>
                      ) : (
                        <img src={Export} alt="Export" className="export-image" />
                      )}
                    </OverlayTrigger>
                  </DropdownToggle>
                  <DropdownMenu className="shadow export">
                    <DropdownItem>
                      <div>
                        <div
                          className="d-flex justify-content-between "
                          style={{ borderBottom: "1px solid #D3D3D3" }}
                        >
                          <span
                            className="f-12"
                            style={{ fontWeight: 500, color: "#757575" }}
                          >
                            Export Notifications
                          </span>
                          <div>
                            <a
                              onClick={(event) => {
                                // handleDownloadHistory(event);
                                handelToggle();
                              }}
                              className="text-primary f-12 font-weight-600"
                              style={{ color: "" }}
                            >
                              View All
                            </a>
                          </div>
                        </div>
                        <>
                          {signalR.count == 1 && (
                            <div>
                              <div className="d-flex mt-2">
                                <img src={ExportPending} />
                                <div className="f-16 font-weight-400 ms-2 word-wrap">
                                  <div className="text-left">
                                    {" "}
                                    Downloading is in progress. We will notify you when it is complete.
                                  </div>
                                </div>
                              </div>

                              {/* <div className="">
                              <Button
                                color="primary"
                                className="export-pending mt-2 w-100"
                              >
                                {" "}
                                <span className="right_5">
                                  <img src={DownLoadingPending} alt="" />
                                </span>{" "}
                                Downlaod
                              </Button>
                            </div> */}
                            </div>
                          )}
                        </>
                        <>
                          {signalR.count != 1 && signalR.messages.length !== 0 && (
                            <div>
                              <div className="mt-2">
                                <div className=" d-flex justify-content-between ms-2">
                                  {/* <div className="margin-right: 5px;"> */}
                                    <div>
                                    <div className="f-16 font-weight-600 text-primary"
                                      style={{
                                        width: "286px",
                                        wordWrap: "break-word",
                                        whiteSpace: "normal"
                                      }}
                                    >
                                      {signalR.messages.fileName}
                                    </div>
                                    
                                    <div
                                      className="f-12 font-weight-500"
                                      style={{ color: "#757575" }}
                                    >
                                      {AppModuleName(signalR.messages.gridCode)}
                                    </div>
                                  </div>
                                  <div
                                    className=" d-flex justify-content-end w-100 h-auto"
                                    style={{
                                      overflow: "auto",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    <div
                                      className="f-12 font-weight-500"
                                      style={{
                                        color: "#757575",
                                      }}
                                    >
                                      <p
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {moment(
                                          new Date(
                                            signalR.messages.fileGeneatedDate
                                          )
                                        ).format("MM/DD/YYYY")}
                                      </p>
                                      <p
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {moment(
                                          new Date(
                                            signalR.messages.fileGeneatedDate
                                          )
                                        ).format("hh:mm A")}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="">
                                <Button
                                  color="primary"
                                  className="search mt-2 w-100"
                                  onClick={() =>
                                    download(signalR.messages.dataExportID)
                                  }
                                >
                                  <span className="right_5">
                                    <img src={DownLoadingCompleted} alt="" />
                                  </span>
                                  Download
                                </Button>
                              </div>
                            </div>
                          )}
                        </>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav className='profile-dropdown'>
                  <DropdownToggle nav className='font-weight-500'>
                    <OverlayTrigger
                      overlay={(props) => (
                        <Tooltip {...props}>
                          View Profile
                        </Tooltip>
                      )}
                      placement="bottom"
                    >
                      <img src={usericon} alt="" />
                    </OverlayTrigger>
                  </DropdownToggle>
                  <DropdownMenu className="shadow">
                    <DropdownItem >
                      <div id="app">
                        <div className="text-end">
                          <div className="text-start">
                            <div className="">
                              <div id="circle-avatar" className="text-center mx-auto my-2 h3">
                                {userName[0]}
                              </div>

                              <h5 className="text-center" style={{ whiteSpace: "normal", color: "#702c62", }}>
                                {userName}
                              </h5>
                              {/* <ul>
                              <li className='my-3'><a style={{fontSize:"12px",textDecoration:"none",color:"#000000",}} href="https://apps.thepharmaforce.com/" target='_blank'>Apps Dashboard</a></li>
                            </ul> */}

                              <div className="d-grid log_info">
                                <Button className="btn btn-secondary" onClick={handleLogout} >
                                  <small>Logout</small>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>


              </Nav>


            }
          </div>
        </div>
        <Modal
          isOpen={isOpen}
          toggle={handelToggle}
          size="lg"
          className="lg "
          style={{marginTop:"90px"}}
        >
          <ModalBody className="m-2 p-4">
            <div className="d-flex justify-content-between">
              <h6 className="f-24 ">All Exports</h6>
              <div onClick={handelToggle}>
                <img src={ExportCancel} />
              </div>
            </div>
            {loading == true ? (
              <Loader opacity={0.01} color="black" />
            ) : (
              <div className="export-modal">
                {downloadHistory.map((item, index) => (
                  <Row className="mt-3  ">
                    <h6
                      className="f-14 font-size-600"
                      style={{ color: "#757575" }}
                    >
                      {item.displayHeader}
                    </h6>
                    <hr></hr>
                    {item.dataExportMessages.map((item1, index) => (
                      <Col md={6} className="mt-2">
                        <div
                          className="p-2"
                          style={{
                            border: "1px solid #D3D3D3",
                            borderRadius: "4px",
                            minHeight: "100px",
                          }}
                        >
                          <div
                            className=" d-flex justify-content-between align-items-center"
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            <div className="f-14 font-weight-600 text-primary"
                              style={{
                                width: "262px",
                                wordWrap: "break-word",
                                whiteSpace: "normal"
                              }}>
                              {item1.fileName}
                            </div>
                            {/* <div
                              className="f-12 font-weight-500"
                              style={{ color: "#757575" }}
                            >
                              {moment(new Date(item1.fileGeneatedDate)).format(
                                "MM/DD/YYYY hh:mm A"
                              )}
                            </div> */}
                            <div
                                      className="f-12 font-weight-500"
                                      style={{
                                        color: "#757575",
                                      }}
                                    >
                                      <p
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {moment(
                                          new Date(
                                            item1.fileGeneatedDate
                                          )
                                        ).format("MM/DD/YYYY")}
                                      </p>
                                      <p
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {moment(
                                          new Date(
                                            item1.fileGeneatedDate
                                          )
                                        ).format("hh:mm A")}
                                      </p>
                                    </div>
                          </div>
                          <div
                            className=" d-flex justify-content-between  mt-2"
                            style={{
                              alignItems: "flex-end",
                            }}
                          >
                            <div
                              className="f-12 font-weight-500"
                              style={{
                                color: "#757575",
                              }}
                            >
                              {item1.gridCode}
                            </div>
                            {/* <div className="">
                              <Button
                                color="primary"
                                className="search-downlaod"
                                onClick={() => download(item1.dataExportID)}
                              >
                                {" "}
                                <span className="right_5">
                                  <img src={DownLoadingPending} alt="" />
                                </span>{" "}
                                Download
                              </Button>
                            </div> */}
                            {item1.exportStatusID == 1 ? (
                              <div className="">
                                <Button
                                  color="primary"
                                  className="search"
                                  onClick={() => download(item1.dataExportID)}
                                >
                                  {" "}
                                  <div className="spinner-container1">

                                  </div>

                                  {"  "}  In Progress
                                </Button>
                              </div>
                            ) : (
                              <div className="">
                                <Button
                                  color="primary"
                                  className="search-downlaod"
                                  onClick={() => download(item1.dataExportID)}
                                >
                                  {" "}
                                  <span className="right_5">
                                    <img src={DownLoadingPending} alt="" />
                                  </span>{" "}
                                  Download
                                </Button>
                              </div>
                            )}

                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                ))}
              </div>
            )}

            {/* {
                downloadHistory.map((item, index) => (
                  <Col md={6}>
                    <div
                      className="p-2"
                      style={{ border: "1px solid #D3D3D3", borderRadius: "4px" }}
                    >
                      <div className=" d-flex justify-content-between align-items-center">
                        <div className="f-16 font-weight-600 text-primary">
                          {item.fileName}
                        </div>
                        <div
                          className="f-12 font-weight-500"
                          style={{ color: "#757575" }}
                        >
                          {moment(new Date(item.fileGeneatedDate)).format("MM/DD/YYYY hh:mm A")}
                        </div>
                      </div>
                      <div
                        className=" d-flex justify-content-between align-items-center"
                      // style={{
                      //   overflow: "auto", // Corrected the typo here
                      //   wordWrap: "break-word",
                      // }}
                      >
                        <div
                          className="f-12 font-weight-500"
                          style={{
                            color: "#757575",
                          }}
                        >
                          {item.gridCode}
                        </div>
                        <div className="">
                          <Button color="primary" className="search " onClick={() => download(item.dataExportID)}>
                            {" "}
                            <span className="right_5">
                              <img src={DownLoadingPending} alt="" />
                            </span>{" "}
                            Download
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              } */}
          </ModalBody>
        </Modal>
      </Navbar>
    </>
  );
};

export default Header;
